export default __webpack_public_path__ + "static/media/1989.1d35fb43.png";